import { loadJSON } from '../loader';
import { loadModules } from './modules';

const loadConfig = (configUrl, callback) => {
    const onConfigLoad = (config) => {
        window.WC.config = config;
        window.WC.config.env.baseURL ??= window.WC._loader.getBaseURL();
        loadModules(config.env.ConfigName, config.env.baseURL);
        callback(config);
    };
    loadJSON({
        url: configUrl,
        successCallback: (result) => {
            onConfigLoad(result);
        },
        errorCallback: (error) => {
            console.error(`WC BASE: error loading config: ${JSON.stringify(error)}`);
        }
    });
};

export { loadConfig };
